import React, { useState, useRef, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import logo from './logo.png';

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
            ? "https://api.digassistant.xyz"
            : "http://localhost:8080";

// Lazy load Stripe - only initialize when needed
const STRIPE_PUBLISHABLE_KEY = 'pk_live_51RxDtdIocRMJajweKCPQhOxGTLsnVNoXvTwgVpzOuOJM0RsIIprx6Kfvrbm9zYxOIdZOPgBb5JDXKKLx14pJnLnq00PuqrXtSm';
let stripePromise = null;

const getStripe = () => {
    if (!stripePromise) {
        stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    }
    return stripePromise;
};

const UpsellServicePage = () => {
const [selectedPlan, setSelectedPlan] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [showCheckout, setShowCheckout] = useState(false);
    const checkoutInstanceRef = useRef(null);
    const clientSecretRef = useRef(null);

    const plans = [
        {
            id: 'monthly',
            name: 'Monthly',
            price: 9.00,
            period: 'month',
            description: '£9.00 a month'
        },
        {
            id: 'yearly',
            name: 'Yearly',
            price: 80.00,
            period: 'year',
            description: '£80.00 a year',
            savings: 25
        }
    ];

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (checkoutInstanceRef.current) {
                checkoutInstanceRef.current.destroy();
                checkoutInstanceRef.current = null;
            }
        };
    }, []);

    const handlePlanSelect = async (planId) => {
        setSelectedPlan(planId);
        // Immediately proceed to payment when plan is selected
        await handleProceedToPayment(planId);
    };

    const handleProceedToPayment = async (planIdParam = null) => {
        const planToUse = planIdParam || selectedPlan;
        if (!planToUse) return;

        // console.log('🚀 handleProceedToPayment called at:', new Date().toISOString());
        setIsProcessing(true);

        try {
            // Create Checkout Session via backend (required for security)
            // console.log('📤 Sending request with plan_type:', selectedPlan, 'at:', new Date().toISOString());

            const response = await fetch(`${API_BASE_URL}/billing/subscription/create/session?plan_type=${planToUse}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Backend error:', errorText);
                throw new Error(`Backend error: ${errorText}`);
            }

            const responseData = await response.json();
            // console.log('Backend response:', responseData);
            // console.log('Response keys:', Object.keys(responseData));
            const { clientSecret } = responseData;

            // Store client secret in ref for use in fetchClientSecret
            clientSecretRef.current = clientSecret;

            // Show the checkout modal first
            setShowCheckout(true);

            // Use requestAnimationFrame for better performance, then initialize checkout
            requestAnimationFrame(async () => {
                // Use another requestAnimationFrame to ensure DOM is ready
                requestAnimationFrame(async () => {
                    try {
                        // Clean up previous checkout instance if it exists
                        if (checkoutInstanceRef.current) {
                            // console.log('Destroying existing checkout instance');
                            checkoutInstanceRef.current.destroy();
                            checkoutInstanceRef.current = null;
                        }

                        const stripe = await getStripe();

                        const fetchClientSecret = async () => {
                            const secret = clientSecretRef.current;
                            // console.log('fetchClientSecret returning:', secret);
                            if (!secret) {
                                throw new Error('Client secret not available');
                            }
                            return secret;
                        };

                        const checkout = await stripe.initEmbeddedCheckout({
                            fetchClientSecret,
                        });

                        // Store the checkout instance in ref for reliable tracking
                        checkoutInstanceRef.current = checkout;

                        // Mount Checkout in the modal
                        checkout.mount('#checkout-container');
                    } catch (error) {
                        console.error('Error initializing checkout:', error);
                        setShowCheckout(false);
                        setIsProcessing(false);
                    }
                });
            });
        } catch (error) {
            console.error('Checkout error:', error);
            setIsProcessing(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/future%20retro%209.9.23_378x.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            position: 'relative'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 0
            }}></div>
            <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{
                    paddingTop: '100px',
                    paddingBottom: '50px'
                }}>
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <img src={logo} alt="Logo" style={{
                            width: '17%',
                            maxWidth: '200px',
                            marginBottom: '40px'
                        }} />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '13px',
                            fontFamily: 'CustomFont',
                            color: '#009e4a',
                            display: 'inline-block',
                            marginBottom: '40px',
                            maxWidth: '400px',
                            lineHeight: '1.4'
                        }}>
                            Membership directly supports Timehri Records: paying artists, funding vinyl releases and nights, and pushing the culture forward
                            <br></br>
                            <br></br>
                            Unlock unlimited wormhole traversal and find even bigger tunes
                            <br></br>
                            <br></br>
                            Access to Voyager mode - talk to Dig Assistant like you're in a record shop. No Discogs URL needed
                            <br></br>
                            <br></br>
                            Push underground culture forward
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '24px' }}>
                            <img src="https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/visa.svg" alt="Visa" style={{ height: '24px' }} />
                            <img src="https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/mastercard.svg" alt="Mastercard" style={{ height: '24px' }} />
                            <img src="https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/paypal.svg" alt="PayPal" style={{ height: '24px' }} />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '60px' }}>
                            {plans.map((plan) => (
                                <div
                                    key={plan.id}
                                    style={{
                                        border: selectedPlan === plan.id ? '2px solid #009e4a' : '1px solid rgba(255, 255, 255, 0.08)',
                                        borderRadius: '14px',
                                        padding: '20px',
                                        width: '200px',
                                        cursor: isProcessing ? 'wait' : 'pointer',
                                        backgroundColor: isProcessing && selectedPlan === plan.id ? 'rgba(0, 158, 74, 0.1)' : 'rgba(255, 255, 255, 0.04)',
                                        backdropFilter: 'blur(4px)',
                                        transition: 'all 0.3s ease',
                                        fontFamily: 'CustomFont',
                                        opacity: isProcessing && selectedPlan !== plan.id ? 0.5 : 1,
                                        pointerEvents: isProcessing ? 'none' : 'auto'
                                    }}
                                    onClick={() => handlePlanSelect(plan.id)}
                                >
                                    <h2 style={{
                                        color: '#009e4a',
                                        marginBottom: '10px',
                                        fontFamily: 'CustomFont',
                                        fontSize: '0.95rem',
                                        fontWeight: '700',
                                        letterSpacing: '0.02em'
                                    }}>
                                        {plan.name}
                                    </h2>
                                    <div style={{
                                        fontSize: '1.05rem',
                                        fontWeight: '700',
                                        marginBottom: '10px',
                                        fontFamily: 'CustomFont',
                                        color: '#009e4a'
                                    }}>
                                        {plan.description}
                                    </div>
                                    {plan.savings && (
                                        <div style={{
                                            color: '#009e4a',
                                            fontWeight: '700',
                                            fontSize: '0.85rem',
                                            marginBottom: '10px',
                                            fontFamily: 'CustomFont'
                                        }}>
                                            Save {plan.savings}% with this discount!
                                        </div>
                                    )}
                                    <div style={{
                                        fontSize: '0.85rem',
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontFamily: 'CustomFont'
                                    }}>
                                        {plan.period === 'month' ? 'Billed monthly' : 'Billed annually'}
                                    </div>
                                    {isProcessing && selectedPlan === plan.id && (
                                        <div style={{
                                            marginTop: '10px',
                                            fontSize: '0.75rem',
                                            color: '#009e4a',
                                            fontFamily: 'CustomFont'
                                        }}>
                                            Loading checkout...
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Embedded Checkout Modal */}
            {showCheckout && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div style={{
                        position: 'relative',
                        width: '90%',
                        maxWidth: '500px',
                        height: '90%',
                        maxHeight: '90vh',
                        backgroundColor: 'black',
                        borderRadius: '10px',
                        overflow: 'hidden'
                    }}>
                        <button
                            onClick={() => {
                                // Clean up checkout instance when modal closes
                                if (checkoutInstanceRef.current) {
                                    checkoutInstanceRef.current.destroy();
                                    checkoutInstanceRef.current = null;
                                }
                                setShowCheckout(false);
                                setIsProcessing(false); // Reset processing state when modal closes
                            }}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'none',
                                border: 'none',
                                color: '#009e4a',
                                fontSize: '20px',
                                cursor: 'pointer',
                                zIndex: 1001,
                                fontFamily: 'CustomFont'
                            }}
                        >
                            ×
                        </button>
                        <div id="checkout-container" style={{
                            width: '100%',
                            height: '100%',
                            overflow: 'auto'
                        }}></div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UpsellServicePage;

